import React from 'react';
import './ConfirmDialog.css';

export const ConfirmDialog = ({ title, message, onConfirm, onCancel, confirmText = 'Подтвердить', cancelText = 'Отмена' }) => {
  return (
    <div className="confirm-dialog-overlay" onClick={onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        {title && <div className="confirm-dialog-header">{title}</div>}
        <div className="confirm-dialog-body">{message}</div>
        <div className="confirm-dialog-actions">
          <button className="confirm-dialog-btn" onClick={onCancel}>
            {cancelText}
          </button>
          <button className="confirm-dialog-btn confirm-dialog-btn_primary" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};
